/* eslint-disable react/prop-types */
import React from 'react';
import { Link } from 'react-router-dom';
import { Container } from './styleMenu';

function GruposMenu() {
  return (
    <>
      <Container>
        <Link to="/group/register" className="link">
          Cadastrar grupo
        </Link>
        <Link to="/group/list" className="link">
          Listar grupo
        </Link>
        <Link to="/group/modulo" className="link">
          Grupo Modulo
        </Link>
        <Link to="/group/permission" className="link">
          Permissão Grupo
        </Link>
      </Container>
    </>
  );
}

export default GruposMenu;
